import { SignUp } from '@clerk/clerk-react';
import PlayClawAuthLayout from '@/app/layout/PlayClawAuthLayout';
import { buildAuthPageUrl, getPlayClawRedirectUrl } from '@/lib/redirects';

const SignUpPage = () => {
  const redirectUrl = getPlayClawRedirectUrl();
  const signInUrl = buildAuthPageUrl('/sign-in');

  return (
    <PlayClawAuthLayout redirectUrl={redirectUrl}>
      <SignUp
        routing="path"
        path="/sign-up"
        signInUrl={signInUrl}
        fallbackRedirectUrl={redirectUrl}
        signInFallbackRedirectUrl={redirectUrl}
      />
    </PlayClawAuthLayout>
  );
};

export default SignUpPage;
